import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import {
  ACCORDION_MAIN_CONTENT_CONTAINER_CONVERTER_TOKEN, AccordionMainContentContainerConverter
} from './accordion-main-content-container.component.converter'
import {
  ACCORDION_MAIN_CONTENT_RIGHT_ROW_CONVERTER_TOKEN, AccordionMainContentRightRowConverter
} from './accordion-main-content-right-row/accordion-main-content-right-row.component.converter'
import {
  ACCORDION_MAIN_CONTENT_LINK_CONVERTER_TOKEN, AccordionMainContentLinkConverter
} from './accordion-main-content-link/accordion-main-content-link.component.converter'
import {
  ACCORDION_MAIN_CONTENT_LEFT_ROW_CONVERTER_TOKEN, AccordionMainContentLeftRowConverter
} from './accordion-main-content-left-row/accordion-main-content-left-row.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        accordionMainContentFeature: {
          module: () => import('./accordion-main-content-container.module').then(m => m.AccordionMainContentContainerModule),
          cmsComponents: ['accordion_main_content_container']
        },
      }
    }),
    {
      provide: ACCORDION_MAIN_CONTENT_CONTAINER_CONVERTER_TOKEN,
      useExisting: AccordionMainContentContainerConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        accordion_main_content_container: ACCORDION_MAIN_CONTENT_CONTAINER_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: ACCORDION_MAIN_CONTENT_RIGHT_ROW_CONVERTER_TOKEN,
      useExisting: AccordionMainContentRightRowConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        accordion_main_content_right_row: ACCORDION_MAIN_CONTENT_RIGHT_ROW_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: ACCORDION_MAIN_CONTENT_LINK_CONVERTER_TOKEN,
      useExisting: AccordionMainContentLinkConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        accordion_main_content_link: ACCORDION_MAIN_CONTENT_LINK_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: ACCORDION_MAIN_CONTENT_LEFT_ROW_CONVERTER_TOKEN,
      useExisting: AccordionMainContentLeftRowConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        accordion_main_content_left_row: ACCORDION_MAIN_CONTENT_LEFT_ROW_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class AccordionMainContentFeatureModule {}
